<template>
    <div class="nav-box">
        <img src="../../assets/home/logo.png" />
        <ul class="menus-box">
            <li :class="active==index?'liActive':hoverActive==index?'liActive':''" @click="itemClick(index)"
                @mouseover="selectStyle(index)" @mouseout="showEwm()" v-for="(item,index) in menus">{{item}}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        // props: {
        //     active: {
        //         default: 0
        //     },
        // },
        // props: ['active'],
        data() {
            return {
                menus: ['HOME', 'GAMES', 'ABOUT US', 'CONTACT'],
                hoverActive: '-1',
                active: 0
            }
        },
        created() { },
        mounted() {
            this.Currpath();
        },
        methods: {
            // 当前路由
            Currpath() {
                switch (this.$route.path) {
                    case '/':
                        this.active = 0;
                        break;
                    case '/games':
                        this.active = 1;
                        break;
                    case '/newsDetail':
                        this.active = 1;
                        break;
                    case '/about':
                        this.active = 2;
                        break;
                    case '/contact':
                        this.active = 3;
                        break;
                    default:
                }
            },
            // click事件
            itemClick(index) {
                let path = this.$route.path;
                switch (index) {
                    case 0:
                        if (path == '/') return;
                        this.$router.push({ path: '/' })
                        break;
                    case 1:
                        if (path == '/games') return;
                        this.$router.push({ path: '/games' })
                        break;
                    case 2:
                        if (path == '/about') return;
                        this.$router.push({ path: '/about' })
                        break;
                    case 3:
                        if (path == '/contact') return;
                        this.$router.push({ path: '/contact' })
                        break;
                    default:
                }
            },
            // hover事件
            selectStyle(index) {
                this.hoverActive = index;
            },
            // out事件
            showEwm() {
                this.hoverActive = '-1';
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'index';
</style>